import { render, staticRenderFns } from "./MobileMenuNextMatches.vue?vue&type=template&id=03be729d&scoped=true&"
import script from "./MobileMenuNextMatches.vue?vue&type=script&lang=js&"
export * from "./MobileMenuNextMatches.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenuNextMatches.vue?vue&type=style&index=0&id=03be729d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03be729d",
  null
  
)

export default component.exports